import { Navigate } from "react-router";
import { useAuth } from "../hooks/useAuth";

export default function AuthRoute({children}) {
    const { token } = useAuth();
    return token
        ? (<Navigate to="/" replace/>)
        : children;
}